import { defineStore } from 'pinia'

export interface PopupType {
    showMenuPopup: boolean
    showProfile: boolean
    showEditProfile: boolean
    showCroperAvatar: boolean
}

export const Popups = defineStore('Popups', {
    state: () => <PopupType>({
        showMenuPopup: false,
        showProfile: false,
        showEditProfile: false,
        showCroperAvatar: false
    }),
    actions: {
        async handelEditProfile() {
            this.showMenuPopup = !this.showMenuPopup
            this.showEditProfile = !this.showEditProfile
        }
    }
})